// import dayjs from "dayjs"

export interface IPreOrderData {
    startDate?: number;
    endDate?: number;
    deliveryDate?: number;
    preType?: string;
    preRelativeDay?: number;
    preQtyPerDay?: number;
}

export interface IPreOrder extends IPreOrderData {
    formattedDeliveryDate(): string | undefined
}

export class PreOrder implements IPreOrder {
    startDate?: number | undefined;
    endDate?: number | undefined;
    deliveryDate?: number | undefined;
    preType?: string | undefined;
    preRelativeDay?: number | undefined;
    preQtyPerDay?: number | undefined;

    formattedDeliveryDate(): string | undefined {
        if (this.deliveryDate !== null) {
            return ""
            // return DateFormat("MMM d").format(
            //     DateTime.fromMillisecondsSinceEpoch(this.deliveryDate! * 1000));
        }
    }
    constructor(data: IPreOrderData) {
        this.startDate = data.startDate
        this.endDate = data.endDate
        this.deliveryDate = data.deliveryDate
        this.preType = data.preType
        this.preRelativeDay = data.preRelativeDay
        this.preQtyPerDay = data.preQtyPerDay
    }

}